import { Plus } from "lucide-react";
import { Button } from "@/shared/ui/button";

interface TagsPanelHeaderProps {
  tagsCount?: number;
  onCreateClick: () => void;
}

export function TagsPanelHeader({
  tagsCount,
  onCreateClick,
}: TagsPanelHeaderProps) {
  return (
    <div className="flex items-center justify-between">
      <div>
        <h2 className="text-2xl font-semibold text-ink-900">
          Tags {tagsCount !== undefined && `(${tagsCount})`}
        </h2>
        <p className="mt-1 text-sm text-ink-600">
          Create and manage tags that can be used across collections and attributes.
        </p>
      </div>
      <Button onClick={onCreateClick}>
        <Plus className="mr-2 h-4 w-4" />
        Add new tag
      </Button>
    </div>
  );
}


